import { render, staticRenderFns } from "./wzbMiddle.vue?vue&type=template&id=3eca5c59&scoped=true&"
import script from "./wzbMiddle.vue?vue&type=script&lang=js&"
export * from "./wzbMiddle.vue?vue&type=script&lang=js&"
import style0 from "./wzbMiddle.vue?vue&type=style&index=0&id=3eca5c59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca5c59",
  null
  
)

export default component.exports